import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Input } from "antd";
import CustomButton from "../../components/Elements/Buttons/CustomButtons";
import { putApi } from "../../api/api_instance";
import { API_URLS } from "../../api/apiUrls";
import { ReactComponent as Back } from "../../assets/svgs/back-button.svg";
import RichEditor from "../../components/Elements/TextEditor/RichEditor";
import PopupCard from "../../components/Cards/PopupCard/PopupCard";

const EditStaticPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const pageData = location.state?.pageData;

  const [pageHeading, setPageHeading] = useState("");
  const [pageContent, setPageContent] = useState("");
  const [loading, setLoading] = useState(false);
  const [popup, setPopup] = useState({
    open: false,
    type: "",
    title: "",
    message: "",
  });
  const [errorMessage, setErrorMessage] = useState({
    pageHeading: "",
    pageContent: "",
  });

  useEffect(() => {
    if (pageData) {
      setPageHeading(pageData.pageHeading || "");
      setPageContent(pageData.pageContent || "");
    }
  }, [pageData]);

  const handleSave = async () => {
    let isValid = true;
    const errors = { pageHeading: "", pageContent: "" };

    if (!pageHeading) {
      errors.pageHeading = "Page Heading is required";
      isValid = false;
    }
    if (!pageContent) {
      errors.pageContent = "Page Content is required";
      isValid = false;
    }

    setErrorMessage(errors);
    if (!isValid) return;

    setLoading(true);
    try {
      const response = await putApi({
        apiUrl: API_URLS.EDIT_STATIC_PAGE(pageData._id),
        data: { pageHeading, pageContent },
      });

      if (response.success) {
        setPopup({
          open: true,
          type: "success",
          title: "Updated",
          message: "Static Page updated successfully!",
        });
        setTimeout(() => navigate(-1), 2000);
      } else {
        setPopup({
          open: true,
          type: "error",
          title: "Failed",
          message: response.message || "Update failed.",
        });
      }
    } catch (error) {
      setPopup({
        open: true,
        type: "error",
        title: "Error",
        message: error.message || "Something went wrong.",
      });
    } finally {
      setLoading(false);
    }
  };

  // Auto-close popup after 2 seconds
  useEffect(() => {
    if (popup.open) {
      const timer = setTimeout(() => {
        setPopup((prev) => ({ ...prev, open: false }));
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, [popup.open]);

  if (!pageData) {
    return <p className="text-center mt-10">No page data found.</p>;
  }

  return (
    <div
      style={{ padding: "40px", backgroundColor: "#fff" }}
      className="h-screen"
    >
      <div className="flex items-center mb-6 gap-2 text-xl text-[#06513D] font-bold">
        <Back onClick={() => navigate(-1)} className="cursor-pointer" />
        <div>{pageHeading}</div>
      </div>
      <div className="flex flex-col gap-6 w-full">
        <Input
          value={pageHeading}
          onChange={(e) => setPageHeading(e.target.value)}
          placeholder="Page Heading"
          className="h-14 rounded-lg"
        />
        {errorMessage.pageHeading && (
          <div className="text-red-500 text-sm">{errorMessage.pageHeading}</div>
        )}

        <RichEditor value={pageContent} onChange={setPageContent} />

        {errorMessage.pageContent && (
          <div className="text-red-500 text-sm">{errorMessage.pageContent}</div>
        )}

        <div className="flex justify-center gap-6 pt-6">
          <CustomButton
            buttonType="button"
            variant="cancel"
            buttonText="Cancel"
            onClick={() => navigate(-1)}
            className="text-base font-normal h-[50px] w-[160px]"
          />
          <CustomButton
            buttonType="button"
            variant="ok"
            buttonText={loading ? "Saving..." : "Save"}
            onClick={handleSave}
            disabled={loading}
            className="text-base font-normal h-[50px] w-[160px]"
          />
        </div>
      </div>

      {popup.open && (
        <div className="fixed inset-0 bg-black/30 z-50 flex items-center justify-center">
          <PopupCard
            type={popup.type}
            title={popup.title}
            message={popup.message}
          />
        </div>
      )}
    </div>
  );
};

export default EditStaticPage;
